module.exports = __webpack_public_path__ + "img/tower_of_supreme_magic_small.8f214c29.png";